import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b1d4d43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline" }

import {
	mask as vMask,
	UiButton,
	UiForm,
	UiInput,
	UiRadioTabs,
	useForm
} from '@/ui-kit';
import { BoolNum } from '@/utils';
import {
	maxValue,
	minValue,
	required
} from '@vuelidate/validators';
import { computed } from 'vue';
import { usePhoneNumberDetails } from '../composition/use-phone-number-details';
import PhoneDetailsPanel from './PhoneDetailsPanel.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberRingMembers',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["loading"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'loading', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {





const {
	phoneNumberDetails,
	forwardingActive,
	updateRingDuration
} = usePhoneNumberDetails();
const {
	fillFormData,
	isFormChanged,
	onSubmit,
	loading,
	formData
} = useForm(
	{ autoRecord: BoolNum.false, ringDuration: 0 },
	{
		ringDuration: {
			required,
			minValue: minValue(10),
			maxValue: maxValue(60)
		}
	}
);

const isDisabled = computed(
	() =>
		!isFormChanged({
			...phoneNumberDetails.value,
			ringDuration:
				phoneNumberDetails.value?.ringDuration.toString()
		})
);

const fillForm = () => {
	fillFormData({
		...phoneNumberDetails.value,
		ringDuration:
			phoneNumberDetails.value?.ringDuration.toString()
	});
};

fillForm();

const submit = onSubmit(async (data) => {
	emit('loading', true);
	await updateRingDuration(data as any).finally(() => {
		emit('loading', false);
	});
});

return (_ctx: any,_cache: any) => {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_openBlock(), _createBlock(PhoneDetailsPanel, {
    title: "Ring members",
    class: _normalizeClass({
			'opacity-50 cursor-not-allowed':
				_unref(forwardingActive)
		}),
    noCollapse: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(UiForm), { onSubmit: _unref(submit) }, {
        default: _withCtx(() => [
          _createVNode(_unref(UiRadioTabs), {
            class: "tabs",
            label: "Auto Record",
            subLabel: "Automatically record all calls to this number. Make sure you stay compliant with recording rules in your region",
            name: "autoRecord",
            noValidate: "",
            modelValue: _unref(formData).autoRecord,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).autoRecord) = $event)),
            options: [
					{ title: 'No', value: 0 },
					{ title: 'Yes', value: 1 }
				],
            disabled: 
					_unref(loading) || _unref(forwardingActive) || __props.disabled
				
          }, null, 8, ["modelValue", "disabled"]),
          _withDirectives(_createVNode(_unref(UiInput), {
            class: "duration",
            label: "Ring Duration",
            subLabel: "Number of seconds before callers are directed to the voicemail",
            name: "ringDuration",
            modelValue: _unref(formData).ringDuration,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).ringDuration) = $event)),
            placeholder: "15",
            disabled: 
					_unref(loading) || _unref(forwardingActive) || __props.disabled
				
          }, null, 8, ["modelValue", "disabled"]), [
            [_unref(vMask), '##']
          ]),
          _createVNode(_component_ElTooltip, {
            disabled: 
					(!_unref(isDisabled) && !_unref(forwardingActive)) ||
					__props.disabled
				,
            "show-after": 500,
            "hide-after": 0,
            enterable: false,
            placement: "left",
            content: "You have no changes to save"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(UiButton), {
                  disabled: 
							_unref(isDisabled) ||
							_unref(forwardingActive) ||
							__props.disabled
						,
                  class: "!h-10 !min-w-24",
                  loading: _unref(loading)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save Changes")
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})